import { LeftCircleOutlined } from "@ant-design/icons";
import React, { ReactElement } from "react";
import { Link, useHistory } from "react-router-dom";

const CampaignHeader = (params): ReactElement => {
  const history = useHistory();
  return (
    <React.Fragment>
      <div className="title d-flex justify-content-between border-bottom mb-0">
        <h5 className="mb-0">
          <Link
            to={""}
            className="mr-2 text-dark"
            onClick={(e) => {
              e.preventDefault();
              history?.goBack();
            }}
          >
            <LeftCircleOutlined />
          </Link>
          {params.leftarea}
        </h5>
        {params.rightarea}
      </div>
    </React.Fragment>
  );
};

export default CampaignHeader;
